import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { deviceInfo } from "appworks/utils/device-info";
import { EpicMobileRulesControl } from "epic/controls/epic-mobile-rules-control";

export class EpicMobileRulesControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        return ["BetBar", "SmartButton", "Autoplay"].indexOf(layer.id) !== -1 && deviceInfo.layoutId === "mobile";
    }

    public build(layer: Layers) {
        return [new EpicMobileRulesControl(layer)];
    }
}
